import * as React from "react";

function SvgPrint(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
        <defs>
          <clipPath id="Print_svg__a">
            <path data-name="Rectangle 4172" fill="none" stroke="rgba(0,0,0,0)" d="M0 0h20.461v19.475H0z" />
          </clipPath>
        </defs>
        <g data-name="Group 12336">
          <path data-name="Rectangle 4173" fill="none" d="M0 0h24v24H0z" />
          <g data-name="Group 12334">
            <g data-name="Group 12333" transform="translate(2 2)" clipPath="url(#Print_svg__a)">
              <path data-name="Rectangle 4169" fill="none" stroke="#3d4251" strokeWidth={1.5} d="M5.453 9.852h9.641v8.992H5.453z" />
              <path
                data-name="Path 44009"
                d="M5.238 15.109H.632V7.156a1.04 1.04 0 011.039-1.039h17.163a1 1 0 011 .995v8h-4.74"
                fill="none"
                stroke="#3d4251"
                strokeWidth={1.5}
              />
              <path data-name="Path 44010" d="M5.453.632h9.641v5.485H5.453z" fill="none" stroke="#3d4251" strokeWidth={1.5} />
              <path data-name="Rectangle 4171" fill="#3d4251" stroke="rgba(0,0,0,0)" d="M16.796 7.639h1.245v1.245h-1.245z" />
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

export default SvgPrint;
